export default "__VITE_ASSET__5b11d682__"